import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.onInput.bind(this))
    this.element.addEventListener("keydown", this.onKeyDown.bind(this))
  }

  onKeyDown(event) {
    this.isBackspace = event.key === "Backspace"
  }

  onInput(event) {
      let input = event.target
      let numbers = input.value.replace(/\D/g, "")

      if (numbers.length > 11) {
        numbers = numbers.slice(0, 11)
      }

      input.value = this.applyMask(numbers)
    }

  applyMask(numbers) {

    if (!numbers) return ""

    const ddd = numbers.slice(0, 2)
    const part1 = numbers.slice(2, numbers.length <= 10 ? 6 : 7)
    const part2 = numbers.slice(numbers.length <= 10 ? 6 : 7)


    if (numbers.length < 3) {
      return `(${ddd}`
    }

    if (numbers.length < 7) {
      return `(${ddd}) ${part1}`
    }

    return `(${ddd}) ${part1}-${part2}`
  }
}
